
/*
    A = 14, Address
    B = 17, Annoucement
    C = 6, Credit note
    D = 3, Delivery Order
    E = 10, Expense
    G = 15, Goods Received
    H = 18, Project
    I = 19, Task
    M = 0, Message
    O = 8, Company or Organization
    P = 5, Purchase Order
    Q = 1, Quotation
    R = 4, Receipt
    S = 7, Statement of account
    U = 9, User
    V = 2, Invoice
    W = 16, Employee
    X = 11, Products and services, items
    Y = 12, Contact, merchant, customer, supplier
    Z = 13, Miscelleanous
    F = 20, Subscription

    top - 19
*/

const MAXEMPLOYEES = 5

const idcfg = [{
  type : "MQVDRPCSOUEXYZAGWBHIF",
  year : "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
  month : "0123456789ABC",
  day : "0123456789ABCDEFGHIJKLMNPQRSTUVW", 
  hour : "0123456789ABCDEFGHIJKLMNP",
  minute : "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ23456789",
  seconds : "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ23456789",
  checksum : 7
}]

const typesOfExpenses = [
  {
    label: 'Bank Charges',
    value: 'banking'
  },
  {
    label: 'CPF',
    value: 'cpf'
  },
  {
    label: 'Entertainment',
    value: 'entertainment'
  },
  {
    label: 'Labour',
    value: 'labour'
  },
  {
    label: 'Loan',
    value: 'loan'
  },
  {
    label: 'Packaging and Shipping',
    value: 'packAndShip'
  },
  {
    label: 'Product Cost',
    value: 'productCost'
  },
  {
    label: 'Professional Services',
    value: 'services'
  },
  {
    label: 'Raw Material',
    value: 'rawMaterial'
  },
  {
    label: 'Rental',
    value: 'rental'
  },
  {
    label: 'Tax',
    value: 'tax'
  },
  {
    label: 'Transportation',
    value: 'transportation'
  },
  {
    label: 'Warehouse',
    value: 'warehouse'
  },
  {
    label: 'Other',
    value: 'other'
  },
]

const typesOfDocument = [
    {
      name : 'Service Order',
      value : 'service'
    },
    { 
      name : 'Quotation',
      value : 'quotation'
    },
    { 
      name : 'Invoice',
      value : 'invoice'
    },
    { 
      name : 'Delivery Order',
      value : 'delivery'
    },
    { 
      name : 'Receipt',
      value : 'receipt'
    },
    { 
      name : 'Purchase Order',
      value : 'purchase'
    },
    /*{ 
      name : 'Credit Note',
      value : 'credit'
    },
    {
      name : 'Statement of Account',
      value : 'statement'
    },*/
    { 
      name : 'Expense', 
      value : 'expense'
    },
    { 
      name : 'Product or Services',
      value : 'pns'
    },
    { 
      name : 'Contact',
      value : 'contact'
    },
    /*{ 
      name : 'Company',
      value : 'organization'
    }*/
    /*{ 
      name : 'Goods Received',
      value : 'goodreceive'
    },
    {
      name : 'Subscription',
      value : 'subscription'
    },*/
]

const paymentModeOption = [
  { label : 'Bank Transfer', value : 'Bank Transfer' },
  { label : 'Cash', value : 'Cash' },
  { label : 'Cheque', value : 'Cheque' },
  { label : 'Credit Card', value : 'Credit Card' },
  { label : 'PayNow', value : 'PayNow' },
  { label : 'Others', value : 'Others' },
]
// for drop down list
const frequencyUnit = [
  { label : 'days', value : 'day'},
  { label : 'weeks', value : 'week'},
  { label : 'months', value : 'month'},
  { label : 'years', value : 'year'}
]

export { idcfg, typesOfDocument, typesOfExpenses, paymentModeOption, frequencyUnit, MAXEMPLOYEES }